/* YDS v87: explicit production colours. Native variants remain the pricing/stock source.
   Used only by the two existing colour configurators; never edits a cart/order remotely. */
(function () {
  'use strict';
  if (window.YDSColourOrder) return;
  const plainColours = [
    { name: 'White', ydsName: 'White', hex: '#FFFFFF', plain: true, legacy: 'White', source: 'YDS Studio · Plain vinyl' },
    { name: 'Black', ydsName: 'Black', hex: '#000000', plain: true, legacy: 'Black', source: 'YDS Studio · Plain vinyl' }
  ];
  function material(c) { return c.plain ? 'Plain vinyl' : c.special ? 'Specialty metallic vinyl' : ''; }
  function label(c) {
    if (c.plain || c.special) return c.name;
    if (/^Approved sample/i.test(c.name || '')) return c.name;
    return (c.ydsName ? c.ydsName + ' | ' : '') + 'Resene ' + c.name;
  }
  function meta(c) { return c.plain || c.special ? material(c) : /^Approved sample/i.test(c.name || '') ? 'Approved physical sample' : 'Resene ' + c.name; }
  function bind(root, formId, getColour, legacy) {
    const form = document.getElementById(formId);
    if (!form) return { sync: function () {} };
    let syncing = false;
    let choices = [];
    try { choices = JSON.parse(legacy && legacy.dataset.ydsColourValues || '[]'); } catch (_) { /* safe legacy fallback */ }
    function details() {
      const values = [];
      const seen = new Set();
      Array.from(form.elements).forEach(function (el) {
        if (!el.name || !el.name.startsWith('options[') || el.disabled) return;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        const name = el.name.slice(8, -1);
        if (/^colou?r$/i.test(name) || seen.has(name) || !el.value) return;
        seen.add(name); values.push({ name: name, value: el.value });
      });
      return values;
    }
    function properties() {
      const c = getColour();
      const options = details();
      const props = {
        'Colour': label(c), 'Material': root.dataset.productHandle === 'auckland-silhouette-wall-decal' && !c.plain && !c.special ? 'Printed vinyl' : material(c),
        '_Colour HEX': c.hex, '_Colour source': c.source || 'Resene',
        '_YDS colour configured': 'v87',
        '_YDS Base colour': legacy ? legacy.value : '',
        '_YDS Options': options.map(function (o) { return o.name + ': ' + o.value; }).join(' | ')
      };
      const size = options.find(function (o) { return /^size$/i.test(o.name); });
      if (size) props.Size = size.value;
      return props;
    }
    function sync() {
      if (syncing) return;
      syncing = true;
      try {
        const c = getColour();
        if (legacy) {
          const base = legacy.dataset.ydsInternalColour || legacy.value;
          const requested = (c.plain || c.special) && c.legacy ? c.legacy : base;
          const nativeValue = choices.find(function (v) { return String(v).toLowerCase() === String(requested).toLowerCase(); });
          // Only choose actual option values. A Resene colour is never a made-up native variant.
          const desired = nativeValue || base;
          if (legacy.value !== desired) {
            legacy.value = desired;
            legacy.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        const props = properties();
        Object.keys(props).forEach(function (key) {
          const name = 'properties[' + key + ']';
          let input = Array.from(root.querySelectorAll('input')).find(function (el) { return el.name === name; });
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.setAttribute('form', formId); root.appendChild(input); }
          input.value = props[key];
        });
      } finally { syncing = false; }
    }
    // new FormData(form) is also how the theme's AJAX Add button serialises the order.
    form.addEventListener('formdata', function (event) {
      const props = properties();
      Object.keys(props).forEach(function (key) { event.formData.set('properties[' + key + ']', props[key]); });
    });
    form.addEventListener('submit', sync, true);
    document.addEventListener('change', function (event) {
      if (event.target.form === form && (event.target.name || '').startsWith('options[')) sync();
    });
    sync();
    return { sync: sync };
  }
  window.YDSColourOrder = { plainColours: plainColours, label: label, meta: meta, material: material, bind: bind };
})();
